/**
 * Ministry route tree — chat-first.
 *
 * Two routes only:
 *   /mohap        → MinistryChatPage (full-screen chat, role-aware)
 *   /mohap/admin  → MinistryAdmin (Connect space — docs, connections,
 *                                  governance, audit, system health)
 *
 * Everything else (briefs, decisions, risks, options matrices, portfolio
 * RAG, review queues) is rendered INLINE in the chat as artifact cards.
 * Those components live in pages/* and are imported by the chat renderer
 * — they are no longer routed as standalone pages.
 */

import { lazy } from "react";
import { Navigate, RouteObject } from "react-router-dom";
import { MinistryShell } from "./MinistryShell";

const MinistryChatPage = lazy(() =>
  import("./pages/MinistryChatPage").then((m) => ({ default: m.MinistryChatPage })),
);
const MinistryAdmin = lazy(() =>
  import("./pages/MinistryAdmin").then((m) => ({ default: m.MinistryAdmin })),
);
const EvidenceTracePage = lazy(() =>
  import("./pages/EvidenceTracePage").then((m) => ({ default: m.EvidenceTracePage })),
);

export const ministryRoutes: RouteObject[] = [
  {
    path: "/mohap",
    element: <MinistryShell />,
    children: [
      { index: true,            element: <MinistryChatPage /> },
      { path: "admin",          element: <MinistryAdmin /> },
      { path: "evidence-trace", element: <EvidenceTracePage /> },
      // Any other /mohap/* → bounce to chat. Direct deep-links into the
      // old standalone surfaces resolve to the chat now.
      { path: "*",              element: <Navigate to="/mohap" replace /> },
    ],
  },
];
